import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@material-ui/core";
import { LocalPhone, Email } from "@material-ui/icons";
import Footer from "../../Flight/components/Home Footer/Footer";
import classes from "../../../components/Flight/components/Services/Services.module.css";
import "./aboutUs.css";

const ContactUs = () => {
  return (
    <>
      <Grid
        container
        style={{ display: "flex", alignItems: "start" }}
        justifyContent="space-between"
      >
        <div
          className={classes["service-container"]}
          style={{
            backgroundImage: "url(/img/contact.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: "750px",
            padding: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className={`${classes["service-container"]} col-md-6`}>
            <div
              className={classes["services"]}
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
                gap: "unset",
              }}
            >
              <Typography
                variant="h5"
                style={{
                  color: "#000000",
                  textTransform: "capitalize",
                  fontSize: "3.875rem",
                  fontWeight: "700",
                  paddingLeft: "8px",
                }}
              >
                Get in touch
              </Typography>
              <Typography
                variant="p"
                component="p"
                style={{
                  color: "#000000",
                  textTransform: "capitalize",
                  fontSize: "1.75rem",
                  fontWeight: "500",
                  paddingLeft: "15px",
                }}
              >
                Want to get in touch? We'd love to hear from you. Here's how you
                can reach us...
              </Typography>
            </div>
          </div>
        </div>
        <div className="contact-container">
          <div className="contact-inside-container">
            <Card className="about-child-card card-shadow col-sm-12 col-md-4 col-lg-5">
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
                className=""
              >
                <CardContent className="about-card-body">
                  <div className="contact-icn">
                    <LocalPhone />
                  </div>

                  <Typography
                    component="div"
                    variant="h5"
                    style={{
                      fontSize: "1.75rem",
                      marginBottom: "1rem",
                      textAlign: "center",
                      marginTop: "0.875rem",
                    }}
                  >
                    Talk to Travelpick
                  </Typography>
                  <Typography
                    variant="p"
                    color="text.secondary"
                    component="p"
                    style={{ marginBottom: "0.75rem", textAlign: "center" }}
                  >
                    Facing any issue? Just pick up the phone to call with a
                    member of our team.
                  </Typography>
                  <Typography
                    component="div"
                    variant="h5"
                    style={{
                      fontSize: "1.25rem",
                      marginBottom: "1rem",
                      textAlign: "center",
                      marginTop: "0.875rem",
                    }}
                  >
                    {React.env.mobile}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
            <Card className="about-child-card card-shadow col-sm-12 col-md-4 col-lg-5">
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
                className=""
              >
                <CardContent className="about-card-body">
                  <div className="contact-icn">
                    <Email />
                  </div>

                  <Typography
                    component="div"
                    variant="h5"
                    style={{
                      fontSize: "1.75rem",
                      marginBottom: "1rem",
                      textAlign: "center",
                      marginTop: "0.875rem",
                    }}
                  >
                    Email Us
                  </Typography>
                  <Typography
                    variant="p"
                    color="text.secondary"
                    component="p"
                    style={{ marginBottom: "0.75rem", textAlign: "center" }}
                  >
                    For more query or issues email us to the below email
                    address.
                  </Typography>
                  <Typography
                    component="div"
                    variant="h5"
                    style={{
                      fontSize: "1.25rem",
                      marginBottom: "1rem",
                      textAlign: "center",
                      marginTop: "0.875rem",
                    }}
                  >
                    {React.env.email}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </div>
        </div>
        <div
          style={{
            maxWidth: "70%",
            margin: "0 auto",
            textAlign: "start",
            marginTop: "3rem",
          }}
        ></div>
      </Grid>
      <Footer />
    </>
  );
};

export default React.memo(ContactUs);
